import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvalidFiscalZipCode extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor trying to set a fiscal zip code with an invalid format', options);
    }
}
export default InvalidFiscalZipCode;
